import { render } from "./AddInfo.vue?vue&type=template&id=46090ebc&scoped=true"
import script from "./AddInfo.vue?vue&type=script&lang=js"
export * from "./AddInfo.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=46090ebc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46090ebc"]])

export default __exports__